import styled from 'styled-components';

import MagnifyingGlassIcon from '@web/assets/svg/UI/magnifying-glass.svg';

export const Fieldset = styled.fieldset`
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.separatorOnWhite};
  border-radius: 4px;
  display: flex;
  flex-wrap: nowrap;
  position: relative;

  &:focus-within {
    border-color: ${({ theme }) => theme.colors.primary};
  }
`;

export const Icon = styled(MagnifyingGlassIcon)`
  color: ${({ theme }) => theme.colors.iconGray};
  left: 10px;
  opacity: 0.65;
  pointer-events: none;
  position: absolute;
  top: 9px;
`;

export const Input = styled.input`
  all: unset;
  color: ${({ theme }) => theme.colors.gray};
  flex: 1;
  height: 34px;
  line-height: 20px;
  min-width: 0;
  padding: 7px 0px 7px 35px;
  width: 100px;

  &::placeholder {
    color: inherit;
    opacity: 0.5;
    text-transform: capitalize;
  }
`;

export const ClearButton = styled.button`
  all: unset;
  color: ${({ theme }) => theme.colors.iconGray};
  cursor: pointer;
  font-size: 24px;
  height: 34px;
  margin-right: -1px;
  opacity: 0.65;
  text-align: center;
  width: 34px;
`;

export const Tips = styled.small`
  color: ${({ theme }) => theme.colors.iconGray};
  display: block;
  font-size: 11px;
  margin-top: 10px;
  opacity: 0.65;

  span {
    display: contents;
  }

  & kbd {
    background-color: ${({ theme }) => theme.colors.iconGray};
    border-radius: 2px;
    color: ${({ theme }) => theme.colors.white};
    font-size: 7px;
    font-family: inherit;
    font-weight: 700;
    padding: 5px;
    vertical-align: text-bottom;
  }
`;
